if (!customElements.get('quick-benefits-bar')) {
  customElements.define(
    'quick-benefits-bar',
    class QuickBenefitsBar extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-viewport]');
        this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.mobileMedia = window.matchMedia('(max-width: 749px)');
        this.autoScrollEnabled = this.dataset.mobileAutoScroll === 'true';
        this.speed = Number(this.dataset.mobileScrollSpeed) || 24;
        this.pauseUntil = 0;
        this.frame = null;
        this.lastTs = null;

        if (!this.viewport) return;

        this.boundTick = this.tick.bind(this);
        this.boundEvaluate = this.evaluate.bind(this);
        this.boundPause = this.pauseTemporarily.bind(this);
        this.boundResume = this.resumeAfterDelay.bind(this);

        this.viewport.addEventListener('pointerdown', this.boundPause, { passive: true });
        this.viewport.addEventListener('touchstart', this.boundPause, { passive: true });
        this.viewport.addEventListener('mouseenter', this.boundPause);
        this.viewport.addEventListener('scroll', this.boundResume, { passive: true });
        this.viewport.addEventListener('pointerup', this.boundResume, { passive: true });
        this.viewport.addEventListener('touchend', this.boundResume, { passive: true });
        this.viewport.addEventListener('mouseleave', this.boundResume);
        this.viewport.addEventListener('focusin', this.boundPause);
        this.viewport.addEventListener('focusout', this.boundResume);

        window.addEventListener('resize', this.boundEvaluate);
        this.mobileMedia.addEventListener?.('change', this.boundEvaluate);
        this.prefersReducedMotion.addEventListener?.('change', this.boundEvaluate);

        this.evaluate();
      }

      disconnectedCallback() {
        this.stop();
        if (!this.viewport) return;
        this.viewport.removeEventListener('pointerdown', this.boundPause);
        this.viewport.removeEventListener('touchstart', this.boundPause);
        this.viewport.removeEventListener('mouseenter', this.boundPause);
        this.viewport.removeEventListener('scroll', this.boundResume);
        this.viewport.removeEventListener('pointerup', this.boundResume);
        this.viewport.removeEventListener('touchend', this.boundResume);
        this.viewport.removeEventListener('mouseleave', this.boundResume);
        this.viewport.removeEventListener('focusin', this.boundPause);
        this.viewport.removeEventListener('focusout', this.boundResume);
        window.removeEventListener('resize', this.boundEvaluate);
        this.mobileMedia.removeEventListener?.('change', this.boundEvaluate);
        this.prefersReducedMotion.removeEventListener?.('change', this.boundEvaluate);
      }

      evaluate() {
        if (
          !this.viewport ||
          !this.autoScrollEnabled ||
          !this.mobileMedia.matches ||
          this.prefersReducedMotion.matches ||
          this.viewport.scrollWidth <= this.viewport.clientWidth + 4
        ) {
          this.stop();
          return;
        }

        if (!this.frame) {
          this.lastTs = null;
          this.frame = requestAnimationFrame(this.boundTick);
        }
      }

      stop() {
        if (this.frame) {
          cancelAnimationFrame(this.frame);
          this.frame = null;
        }
        this.lastTs = null;
      }

      pauseTemporarily() {
        this.pauseUntil = Date.now() + 1800;
      }

      resumeAfterDelay() {
        this.pauseUntil = Date.now() + 1400;
        this.evaluate();
      }

      tick(ts) {
        if (!this.viewport) {
          this.stop();
          return;
        }

        if (!this.lastTs) {
          this.lastTs = ts;
        }

        const delta = ts - this.lastTs;
        this.lastTs = ts;

        if (Date.now() >= this.pauseUntil) {
          const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;

          if (maxScroll > 0) {
            const next = this.viewport.scrollLeft + (this.speed * delta) / 1000;
            this.viewport.scrollLeft = next >= maxScroll ? 0 : next;
          }
        }

        this.frame = requestAnimationFrame(this.boundTick);
      }
    }
  );
}
